module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/css-grid-02-first-grid.json
// module id = 409
// module chunks = 123764462342234